import React from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import '../styles/lines.css';

const TimelineUiUx = () => {
    const steps = [
        {
            title: "STEP ONE",
            subtitle: "Design Brief",
            description: "The design brief starts with a product scope – either created by us or provided by you – with all the user stories, UX personas or list of features and stakeholder analysis.",
           
        },
        {
            title: "STEP TWO",
            subtitle: "Key Screens",
            description: "We start by creating the most important screens for your product. This allows you to see exactly how your product will look and then approve the design.",
        },
        {
            title: "STEP THREE",
            subtitle: "All Screens",
            description: "Once you are happy and approve the Key Screens we extend the design to the remaining screens and deliver the full product UX/UI.",
        },
    ];

    return (
        <motion.div
            className="p-8 bg-gray-100 min-h-screen flex justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <VerticalTimeline>
                {steps.map((step, index) => (
                    <VerticalTimelineElement
                        key={index}
                        className="vertical-timeline-element--work"
                        contentStyle={{
                            background: "#fff",
                            color: "#333",
                            boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)",
                        }}
                        contentArrowStyle={{ borderRight: "7px solid #fff" }}
                        iconStyle={{ background: "#037AC0", color: "#fff" }}
                        icon={<FaCheckCircle />}
                        position={index % 2 === 0 ? "left" : "right"}
                    >
                        <h3 className="text-xl font-bold text-[#037AC0] font-poppins">{step.title}</h3>
                        <h4 className="text-2xl font-bold mt-2 font-poppins">{step.subtitle}</h4>
                        <p className="mt-2 text-gray-600 font-poppins">{step.description}</p>
                       
                    </VerticalTimelineElement>
                ))}
            </VerticalTimeline>
        </motion.div>
    );
};

export default TimelineUiUx;
